export default __webpack_public_path__ + "static/media/AW1OCT22.adc1b9fb.jpg";